import { useEffect, useRef } from 'react';
import { datadogRum } from '@datadog/browser-rum';

export const useTabVisibilityTracking = (viewName, path) => {
  const tabActive = useRef(document.visibilityState === 'visible');
  const hasStartedView = useRef(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = document.visibilityState === 'visible';

      if (isVisible && !tabActive.current) {
        datadogRum.startView(`${viewName}-resume`, { path });
        tabActive.current = true;
        hasStartedView.current = true;
      } else if (!isVisible && tabActive.current) {
        datadogRum.startView(`${viewName}-pause`, { path });
        tabActive.current = false;
      }
    };

    if (tabActive.current && !hasStartedView.current) {
      datadogRum.startView(viewName, { path });
      hasStartedView.current = true;
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [viewName, path]);
};
